import { ip as validateIpValidator } from '@/data/validators';

export default {
  methods: {
    validateIp(ip) {
      if (!ip || typeof ip !== 'string') {
        return false;
      }
      return validateIpValidator(ip);
    },
    cleanIp(ip) {
      if (!ip || typeof ip !== 'string') {
        return '';
      }
      const value = String(ip);
      let result = '';
      let digitCount = 0;
      let dotCount = 0;
      for (let i = 0; i < value.length; i += 1) {
        const char = value[i];
        if (char >= '0' && char <= '9') {
          if (digitCount < 12) {
            result += char;
            digitCount += 1;
          }
        } else if (char === '.') {
          if (digitCount > 0 && dotCount < 3 && !result.endsWith('.')) {
            result += char;
            dotCount += 1;
          }
        }
      }
      return result.replace(/^\.+|\.+$/g, '');
    },
    isDuplicateIp(ip, ipList) {
      if (!ip || !Array.isArray(ipList)) {
        return false;
      }
      const cleanedIp = this.cleanIp(ip);
      return ipList.some((item) => {
        const itemIp = typeof item === 'string' ? item : item.ip;
        return this.cleanIp(itemIp) === cleanedIp;
      });
    },
    formatIp(ip) {
      const cleaned = this.cleanIp(ip);
      if (!cleaned) {
        return '';
      }
      const parts = cleaned.split('.').filter(part => part !== '');
      if (parts.length !== 4) {
        return cleaned;
      }
      return parts.join('.');
    },
    isValidIpFormat(ip) {
      return this.validateIp(ip);
    },
    getIpValidationError(ip) {
      if (!ip || ip.trim() === '') {
        return 'Por favor, informe um endereço IP';
      }
      if (!this.validateIp(ip)) {
        return 'Endereço IP inválido.';
      }
      return null;
    },
    formatIpFromDigits(value) {
      const digits = (value || '').replace(/\D/g, '').slice(0, 12);
      if (digits.length === 0) {
        return '';
      }
      const totalDigits = digits.length;
      const maxSegments = totalDigits > 6
        ? 4
        : Math.min(4, Math.max(1, Math.ceil(totalDigits / 3)));
      const segments = [];
      let startIndex = 0;
      let remaining = totalDigits;
      for (let i = 0; i < maxSegments; i += 1) {
        const segmentsRemaining = maxSegments - i;
        const maxTake = Math.min(3, remaining - Math.max(segmentsRemaining - 1, 0));
        const take = Math.max(1, Math.min(3, maxTake));
        segments.push(digits.substr(startIndex, take));
        startIndex += take;
        remaining -= take;
      }
      return segments.join('.');
    },
  },
};
